/**
 * 
 * Supplemental file for Favorites customizations in order to assist in upgrade paths.
 *
 */
define('modules/Favorites/FavoritesPreviewCustomizations',[
    'jquery',
    'global/all',
    'modules/Cart/all',
    'modules/QuickView/QuickView',
    'modules/Cart/CartManagerCustomizations',
    './FavoritesCustomizations',
    'modules/Cart/CartLocker',
    'plugins/magnific-popup'
], function ($, Roc, Cart, QuickView, CartManagerCustom, FavoritesCustomizations, CartLocker) {
    'use strict';

    var itemToUpdate = null;

    function addItemToCartEvt() {
        $(document).on('click', '[data-roc-action="addToCartFromFavorites"]', function () {
            var $itemWrapper = $(this).closest('.itemWrapper');
            var itemData = $itemWrapper.data();
            var qty = parseInt($itemWrapper.find('.itemAction input.addQty').val());

            itemToUpdate = {
                'ListId': itemData.listId,
                'ProductId': itemData.productId,
                'AddQty': isNaN(qty) ? 1 : Math.max(1, qty),
                'ItemId': itemData.itemId,
                'GroupId': itemData.groupId
            };

            // this piece of code is copied from Favorites module to ensure compability with TempAddressId requirement
            var customFields = null;
            var tempAddressId = CartManagerCustom.getTempAddressId();
            if (tempAddressId) {
                customFields = {
                    "TempAddressId": tempAddressId
                };
            }

            if (itemData.productType === 'Group') {
                QuickView.getProduct(itemToUpdate.ProductId);
            } else {
                CartLocker.isCartLocked()
                    .then(function() {
                        Roc.Core.lockButton('#btnAddToCart' + itemToUpdate.ItemId);
                        Cart.CartManager.addCartItem(itemToUpdate.ProductId, itemToUpdate.AddQty, itemToUpdate.GroupId, null, null, null, customFields);
                    });
            }
        });
    }

    function bindEvents() {
        addItemToCartEvt();
        Roc.EventManager.bind(Roc.Events.cart.ADD_ITEM, function (xhr) {
            var data = xhr || {};

            if (!data.success) {
                var errorMessage = 'An error occurred while trying to add the item to your cart.';
                if (data && data.errorMessage) {
                    errorMessage = data.errorMessage;
                } else if (data.details && data.details.errorMessages && data.details.errorMessages.length > 0) {
                    errorMessage = '';
                    for (var i = 0; i < data.details.errorMessages.length; i++) {
                        errorMessage += data.details.errorMessages[i].errorMessage + '\n';
                    }
                }

                Roc.UI.displayErrorPopup(errorMessage);
                Roc.Core.releaseLockedButton('#btnAddToCart' + itemToUpdate.ItemId);
                return;
            }

            Roc.Core.releaseLockedButton('#btnAddToCart' + itemToUpdate.ItemId);
            itemToUpdate = null;
        });
    }

    function init() {
        bindEvents();
        FavoritesCustomizations.init();
    }

    var FavoritesPreviewCustomizations = {
        init: init
    };

    Roc.Logger.debug('FavoritesPreviewCustomizations.js Loaded:', FavoritesPreviewCustomizations);

    return FavoritesPreviewCustomizations;


});
